import { CellValueChangedEvent } from 'ag-grid-community';
import { useCallback } from 'react';
import { HRM2120_R01DetailDto } from '../Dto_HRM2120_R01';
import { useHRM2120_R01Store } from '../Store_HRM2120_R01';

/** 배정 방식이나 근무조 변경에 맞춰 다른 배정값을 정리하고 수정 상태를 기록한다. */
export const useHRM2120_R01CellChange = () => {
    const updateHRM2120_R01DetailList = useHRM2120_R01Store(state => state.updateHRM2120_R01DetailList);
    const handleCellChange = useCallback((event: CellValueChangedEvent<HRM2120_R01DetailDto>) => {
        if (!event.data || event.oldValue === event.newValue) return;

        const row = event.data;
        if (event.colDef.field === 'assignType') {
            if (event.newValue === 'ROT') {
                updateHRM2120_R01DetailList(row.valueIndex, {
                    ...row,
                    shiftCd: '',
                    rotGroup: row.rotGroup || 'A',
                    isModified: true,
                });
                return;
            }
            if (event.newValue === 'FIX') {
                updateHRM2120_R01DetailList(row.valueIndex, {
                    ...row,
                    shiftCd: row.shiftCd || 'D',
                    rotGroup: '',
                    isModified: true,
                });
                return;
            }
        }
        /** 교대 행에서 고정 근무조를 고르면 배정 방식도 고정으로 전환한다. */
        if (event.colDef.field === 'shiftCd') {
            updateHRM2120_R01DetailList(row.valueIndex, {
                ...row,
                assignType: 'FIX',
                rotGroup: '',
                isModified: true,
            });
            return;
        }
        updateHRM2120_R01DetailList(row.valueIndex, {
            ...row,
            isModified: true,
        });
    }, [updateHRM2120_R01DetailList]);
    return { handleCellChange };
};
